import { LazyQueryExecFunction } from '@apollo/client/react';
import {
  Department,
  DepartmentsSearchListQuery,
  DepartmentsSearchListQueryVariables,
  SortDirectionEnum,
} from 'graphql-common';
import { DEFAULT_SEARCH_LIST_VARIABLES } from '@lib/enums/urls';
import getLoadOptionsResult from '@lib/utils/getLoadOptionsResult';
import createSearchFilters, {
  defaultSearchListSchema,
} from '@lib/utils/createSearchFilters';
import { LoadOptionsParams } from '@lib/components/Select/types';

type FetchLazyQuery = LazyQueryExecFunction<
  DepartmentsSearchListQuery,
  DepartmentsSearchListQueryVariables
>;

export const fetchSearchList = async (
  searchQuery: string,
  fetchLazyQuery: FetchLazyQuery,
  page: number,
) => {
  const options: { variables: DepartmentsSearchListQueryVariables } = {
    variables: {
      ...DEFAULT_SEARCH_LIST_VARIABLES,
      page,
      sorts: { name: SortDirectionEnum.Asc },
    },
  };
  if (searchQuery) {
    // Without a search query, `departments` returns only root departments;
    // a `name` filter flattens the search across every depth (BE contract).
    options.variables.filters = createSearchFilters(
      searchQuery,
      defaultSearchListSchema,
    );
  }
  const { data } = await fetchLazyQuery(options);
  return getLoadOptionsResult(
    data,
    (dataItem: Department) => ({
      value: dataItem.id,
      label: dataItem.name,
      data: { path: dataItem.path, color: dataItem.color },
    }),
    searchQuery,
  );
};

export const getDepartmentsLoadOptions =
  (fetchLazyQuery: FetchLazyQuery) =>
  (searchQuery: string, loadedOptions: unknown, params: LoadOptionsParams) =>
    fetchSearchList(searchQuery, fetchLazyQuery, params?.page || 1);
